import { render, staticRenderFns } from "./ClassroomType.vue?vue&type=template&id=6e27dda4"
import script from "./ClassroomType.vue?vue&type=script&lang=js"
export * from "./ClassroomType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports